import * as Yup from "yup";

import { FREQUENCY_BANDS, GATEWAY_EUI_MAX_LENGTH, GATEWAY_MODELS } from "entities/gateways";

const HEX_REGEX = /^[0-9A-Fa-f]+$/;

export const validationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required("Please fill out this field.")
    .max(100, "Maximum 100 characters."),
  companyId: Yup.string().trim().required("Please choose an option."),
  portfolioId: Yup.string(),
  gatewayModel: Yup.string()
    .required("Please choose an option.")
    .oneOf([...GATEWAY_MODELS], "Please choose an option."),
  frequencyBand: Yup.string()
    .required("Please choose an option.")
    .oneOf([...FREQUENCY_BANDS], "Please choose an option."),
  gatewayEui: Yup.string()
    .trim()
    .required("Please fill out this field.")
    .length(
      GATEWAY_EUI_MAX_LENGTH,
      `Gateway EUI must be exactly ${GATEWAY_EUI_MAX_LENGTH} hex characters.`,
    )
    .matches(HEX_REGEX, "Only hexadecimal characters (0-9, A-F) are allowed."),
});
